module.exports = __webpack_public_path__ + "static/img/no-regulation.9b595d3f.png";